import attribute from './attribute.js'

export default class configuration{
    constructor(){
        //p0->p1
        this.language = new attribute();
        this.market = new attribute();
        this.configurator = new attribute(); //de tipus atribute -> atribut o objecte que te idconfigurador nom , imatge, url, classe sencera

        //p1->p2
        this.familyParameters = [];//vindra del servidor cadascun dels atributs de la pantalla 2,
        
        //p2->p3
        this.elements = []; //p3 main elements
        this.mainElementParameters = [];
        //this.productFamily = productFamily;

        //p3->p4
        this.results = [];
                
        this.stage = 0; //pantalla a la cual estem  

        this.validation = {
            errors: [],
            warnings: [],
            valid: false
        }

        this.time_last_modification = new Date();

    }
}
